<template>
	<div class="agreement_box" :style="{ marginTop: marginTop, fontSize: '0.6rem ' }">
		<div class="new_flex" @click="$emit('seletBtn')">
			<img class="selekt_img_box" :src="seletBtndata ? imgIcoactivate : imgIco">
			<div class="text1" v-if="loginType == 2">注册即同意</div>
			<div class="text1" v-else>登录即同意</div>
		</div>
		<div class="xiyibox">
			<div class="xiyibox" v-if="loginType == 2">
				<div @click="$emit('goAgreement', 3)" class="text2">《注册服务协议》</div>
				<div class="text1">和</div>
				<div @click="$emit('goAgreement', 2)" class="text2">《隐私政策》</div>
			</div>
			<div class="xiyibox" v-else>
				<div @click="$emit('goAgreement', 1)" class="text2">《用户协议》</div>
				<div class="text1">和</div>
				<div @click="$emit('goAgreement', 2)" class="text2">《隐私政策》</div>
			</div>
		</div>
	</div>
</template>

<script>


export default {
	name: 'Agreement',
	props: {
		seletBtndata: {
			type: Boolean,
			default: false
		},
		imgIcoactivate: {
			type: String,
			default: ""
		},
		imgIco: {
			type: String,
			default: ""
		},
		marginTop: {
			type: String,
			default: "0"
		},
		loginType: {
			type: Number,
			default: ""
		}
	},
	methods: {

	}
}
</script>

<style lang="scss" scoped>
.agreement_box {
	display: flex;
	align-items: center;
	justify-content: space-between;

	.selekt_img_box {
		width: 0.6rem; // 24rpx
		height: 0.6rem; // 24rpx
		margin-right: 0.2rem; // 8rpx
		cursor: pointer;
	}

	.new_flex {
		display: flex;
		align-items: center;
	}

	.text1 {
		font-size: 0.6rem; // 24rpx
		color: rgba(142, 142, 142, 1);
	}

	.xiyibox {
		display: flex;
		align-items: center;
		font-size: 0.6rem; // 24rpx

		.text1 {
			color: rgba(142, 142, 142, 1);
		}

		.text2 {
			color: #855200;
			cursor: pointer;
		}
	}
}
</style>